module.exports = __webpack_public_path__ + "static/media/ubicacion.c1851e2c.png";